// project
import { http } from "@/http";

type UserLoginCredentials = {
	email:string;
	password:string;
};

type UserLoginResult = {
	token:string;
};

export const loginUser = async (credentials:UserLoginCredentials):Promise<UserLoginResult> => {
	const { data } = await http.post("auth/users/login", credentials);
	return data;
};
